export const styles = () => ({
  small: {
    maxWidth: '80px',
    fontSize: '0.8125rem',
    textAlign: 'center',
  },
})
